const n = "styles-module__container___FCrZc", t = "styles-module__input_container___-ZZ4Y", e = "styles-module__label___4OMyY", _ = {
  container: n,
  input_container: t,
  label: e
};
export {
  n as container,
  _ as default,
  t as input_container,
  e as label
};
